<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="filter-refresh-btn">
    <span>초기화</span>
    <button @click="refreshFilter">
      <img src="../../assets/images/ex-reset.png"
        srcset="
          ../../assets/images/ex-reset@2x.png 2x,
          ../../assets/images/ex-reset@3x.png 3x"
        alt="초기화 버튼"
      />
    </button>
  </div>
</template>

<script>
  export default {
    name: 'RefreshBtn',
    props: {
      callback: {
        type: Function,
        default: () => {}
      }
    },
    methods: {
      refreshFilter () {
        this.$store.dispatch('resetFilter')
        this.callback()
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .filter-refresh-btn {
    height: 100%;
    line-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    span {
      color: @brown-grey;
    }
    button {
      background-color: @white;
      padding-top: .75rem;
    }
  }
</style>

<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .filter-refresh-btn {
      background: @very-light-pink;

      span {
        display: none;
      }
      button {
        padding: 0;
        background: transparent;
        img {
          width: 1.8rem;
          height: 1.9rem;
        }
      }
    }
  }
</style>

